export default __webpack_public_path__ + "static/media/FEMUR_AXIAL.04b25e8d.jpg";